import { __extends } from "tslib";
import { ASObject } from '@awayfl/avm2';
var TextRun = /** @class */ (function (_super) {
    __extends(TextRun, _super);
    function TextRun(beginIndex /*int*/, endIndex /*int*/, textFormat) {
        var _this = _super.call(this) || this;
        _this._beginIndex = beginIndex | 0;
        _this._endIndex = endIndex | 0;
        _this._textFormat = textFormat;
        return _this;
    }
    Object.defineProperty(TextRun.prototype, "beginIndex", {
        get: function () {
            return this._beginIndex;
        },
        set: function (value) {
            this._beginIndex = value | 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextRun.prototype, "endIndex", {
        get: function () {
            return this._endIndex;
        },
        set: function (value) {
            this._endIndex = value | 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TextRun.prototype, "textFormat", {
        get: function () {
            return this._textFormat;
        },
        set: function (value) {
            this._textFormat = value;
        },
        enumerable: true,
        configurable: true
    });
    TextRun.prototype.clone = function () {
        return new TextRun(this.beginIndex, this.endIndex, this.textFormat.clone());
    };
    TextRun.prototype.containsIndex = function (index) {
        return index >= this._beginIndex && index < this._endIndex;
    };
    TextRun.prototype.intersects = function (beginIndex, endIndex) {
        return Math.max(this._beginIndex, beginIndex) < Math.min(this._endIndex, endIndex);
    };
    TextRun.classInitializer = null;
    return TextRun;
}(ASObject));
export { TextRun };
